import { render, staticRenderFns } from "./SocialMediaPanel.vue?vue&type=template&id=11f50fda&"
import script from "./SocialMediaPanel.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports